<fe-header></fe-header>
<main>
    <fe-promotion-hero
        [promotion]="promotionDetails?.data?.promotion"
    ></fe-promotion-hero>
    <fe-promotion-offer></fe-promotion-offer>
    <fe-promotion-reasons></fe-promotion-reasons>
    <fe-promotion-terms
        [terms]="promotionDetails?.data?.promotion?.termsAndConditions"
    ></fe-promotion-terms>
</main>
<fe-footer></fe-footer>
